// @flow
import React, { useContext } from 'react';
import { SPUserCommitDetailsContext } from '@streaming-projects/user-commit-details/contexts/SPUserCommitDetailsContext';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { getIfCustomerViewIsEnabled } from '@src/common-utils/utils';
import { If } from '@presentational/If';
import { PositiveMessageWithHeaderText } from '@presentational/messages/PositiveMessageWithHeaderText';
import { Spacer } from '@presentational/spacing/Spacer';
import {
  getCommittedCapacityEligibilityData,
  getMetricLabelFromMetricName,
} from '@streaming-projects/user-commit-details/committed-capacity/utils';

const getIfCustomerIsEligibleForCommittedCapacityAndCorrespondingMessage = (data) => {
  const committedCapacityEligibilityData = getCommittedCapacityEligibilityData(data);

  const eligibleMetrics = [];

  Object.entries(committedCapacityEligibilityData).forEach(([metricName, metricData]) => {
    if (metricData?.enabled === true) {
      eligibleMetrics.push(getMetricLabelFromMetricName(metricName));
    }
  });

  if (eligibleMetrics.length === 0) {
    return { isCommittedCapacityApplicableForAnyMetric: false, message: '' };
  }

  const joinedEligibleMetricsString = eligibleMetrics.join(' , ');
  const eligibilityMessage = `Customer is eligible for Committed capacity for metrics: { ${joinedEligibleMetricsString} }`;

  return { isCommittedCapacityApplicableForAnyMetric: true, message: eligibilityMessage };
};

export const SPUserCommitCommittedCapacityAlertContainer = () => {
  const commitData = useContext(SPUserCommitDetailsContext);
  const spOrgData = useContext(SPOrgContext);
  const isCustomerViewEnabled = getIfCustomerViewIsEnabled(spOrgData);
  const { isCommittedCapacityApplicableForAnyMetric, message } =
    getIfCustomerIsEligibleForCommittedCapacityAndCorrespondingMessage(commitData);
  const shouldShowAlert = isCommittedCapacityApplicableForAnyMetric && !isCustomerViewEnabled;

  return (
    <If test={shouldShowAlert}>
      <Spacer y={25} />
      <PositiveMessageWithHeaderText message={message} />
    </If>
  );
};
